export default [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'agent',
        type: 'address',
      },
      {
        internalType: 'bytes32',
        name: 'name',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: 'permissions',
        type: 'uint256',
      },
    ],
    name: 'authorizeAgent',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'agent',
        type: 'address',
      },
    ],
    name: 'revokeAgent',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'revokeAllAgents',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'trader',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'agent',
        type: 'address',
      },
    ],
    name: 'getAgentAuth',
    outputs: [
      {
        internalType: 'address',
        name: 'agent',
        type: 'address',
      },
      {
        internalType: 'bytes32',
        name: 'name',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: 'permissions',
        type: 'uint256',
      },
      {
        internalType: 'uint32',
        name: 'authorizedAt',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const;
